export default "__VITE_ASSET__Cb$P3I4B__"